export default {
  descriptionsContacts: null,
  cidades: null,
  estados: null,
  cidadesRaw: null,
  features: null
}
